import { render, staticRenderFns } from "./AI-book.vue?vue&type=template&id=5d8fe684&scoped=true"
import script from "./AI-book.vue?vue&type=script&lang=js"
export * from "./AI-book.vue?vue&type=script&lang=js"
import style0 from "./AI-book.vue?vue&type=style&index=0&id=5d8fe684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8fe684",
  null
  
)

export default component.exports